import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/category/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function create(values) {
  return request({
    url:    '/category/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/category/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/category/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function findPrimaryLevel() {
  return request({
    url:    '/category/list/filter/primary-level',
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/category/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const CategoryService = {
  get, create, update, remove, find, findPrimaryLevel
}

export default CategoryService;
